import React, { Component } from "react"
import Img from 'gatsby-image'
import Link from 'gatsby-link'

import { IntlProvider, FormattedMessage } from "react-intl"
import en from "react-intl/locale-data/en"
import enMessages from "../../locales/en.js"
import it from "react-intl/locale-data/it"
import itMessages from "../../locales/it.js"

const messages = {
  it: itMessages,
  en: enMessages
}

class Footer extends Component {
  render() {

    let locale = this.props.language
    let prefix = locale === "" ? "en" : locale;
    let logo = this.props.logo
    let houses = this.props.houses
    let footer = this.props.footer

    return(
      <footer className="footer">
        <div className="wrap">
          <div className="grid">
            <div className="grid__item width-8-12 lap-3-12">
              <div className="cartiglio">
                <Img
                  className="footer__logo"
                  sizes={ logo.sizes }
                />
                <div
                  className="footer__name"
                >
                  <ul>
                    <li>Advantage</li>
                    <li
                      style={{
                        lineHeight: 0.7,
                      }}
                    >
                      Premier Residence</li>
                  </ul>
                </div>
              </div>
              <div
                className="footer__description"
                dangerouslySetInnerHTML={{
                  __html: footer
                }}
              />
            </div>
            <div className="grid__item width-4-12 lap-9-12">
              <h3 className="footer__title">
                <IntlProvider
                  locale={ prefix }
                  messages={ messages[prefix] }
                >
                  <FormattedMessage id={"houses"} />
                </IntlProvider>
              </h3>
              {
                (prefix === "en")
                && (
                  <div>
                    <a
                      className="footer__link"
                      href="https://www.iubenda.com/privacy-policy/59983574"
                      target="_blank"
                    >
                      Privacy Policy
                    </a>
                    <a
                      className="footer__link"
                      href="https://www.iubenda.com/privacy-policy/59983574/cookie-policy"
                      target="_blank"
                    >
                      Cookie Policy
                    </a>
                  </div>
                )
              }
              {
                (prefix === "it")
                && (
                  <div>
                    <a
                      className="footer__link"
                      href="https://www.iubenda.com/privacy-policy/53054619"
                      target="_blank"
                    >
                      Privacy Policy
                    </a>
                    <a
                      className="footer__link"
                      href="https://www.iubenda.com/privacy-policy/53054619/cookie-policy"
                      target="_blank"
                    >
                      Cookie Policy
                    </a>
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js